module.exports = __webpack_public_path__ + "img/Cultura_oct_2023.3191f500.png";